import { ReactNode } from 'react';
import styled from 'styled-components';

import { colors } from 'styles/theme/colors';

type Props = {
  icon: ReactNode;
  text: ReactNode;
  action?: ReactNode;
};

export default function AdmissionEmptyState({ icon, text, action }: Props) {
  return (
    <Container>
      <IconCircle>{icon}</IconCircle>
      <Text>{text}</Text>
      {action}
    </Container>
  );
}

export const IconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: ${colors.aiPurple10};
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 80px 24px;
`;

const Text = styled.p`
  font-size: 14px;
  line-height: 22px;
  color: ${colors.black75};
  text-align: center;
  margin: 0;
  max-width: 640px;
`;
